import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/cookie-consent/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/footer/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/index.js");
;
import(/* webpackMode: "eager" */ "/app/app/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.min.css");
